import React, { useState, useEffect } from "react";
import { cn } from "@/utils/utils";
import { Button } from "@/components/ui/button";
import { Menu, X, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle mobile menu toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header
      className={cn(
        "fixed top-0 w-full z-50 transition-all duration-300 py-3 px-6 md:px-12 border-b border-slate-200",
        isScrolled ? "bg-white/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      )}
    >
      <div className="container mx-auto flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center justify-center gap-2.5">
          <img
            src="/images//d-logo.png"
            alt="Dhansamuh Logo"
            className="h-9 w-auto"
          />
          <span className="text-xl font-display font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            Dhansamuh
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-10">
          <a
            href="#features"
            className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all hover:after:w-full"
          >
            Features
          </a>
          <a
            href="#how-it-works"
            className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all hover:after:w-full"
          >
            How It Works
          </a>
          <Link
            to="/learn-more"
            className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors relative inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-gradient-to-r from-blue-800/10 to-indigo-500/10 hover:from-blue-600/20 hover:to-blue-800/20 transform  "
          >
            Learn More
            <ArrowRight size={16} className="text-blue-600" />
          </Link>
          <Link
            to="/waitlist"
            className="relative bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium py-2 px-6 rounded-full transform transition-all duration-300 hover:shadow-lg hover:shadow-blue-300/20"
            onClick={() => (window.location.href = "#waitlist")}
          >
            <span className="relative z-10">Join Waitlist</span>
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-foreground p-1 rounded-full hover:bg-slate-100 transition-colors"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white/95 backdrop-blur-md shadow-lg border-b border-slate-100 animate-in fade-in slide-in-from-top duration-300">
          <div className="py-5 px-6 flex flex-col space-y-4">
            <a
              href="#features"
              className="text-foreground/80 py-2.5 px-4 hover:bg-blue-50 rounded-lg transition-colors font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Features
            </a>
            <a
              href="#how-it-works"
              className="text-foreground/80 py-2.5 px-4 hover:bg-blue-50 rounded-lg transition-colors font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              How It Works
            </a>
            {/* <a
              href="#testimonials"
              className="text-foreground/80 py-2.5 px-4 hover:bg-blue-50 rounded-lg transition-colors font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Testimonials
            </a> */}
            <Link
              to="/learn-more"
              className="text-foreground/80 py-2.5 px-4 rounded-lg transition-colors font-medium inline-flex items-center gap-1.5 bg-gradient-to-r from-blue-400/10 to-blue-600/10 hover:from-blue-500/20 hover:to-blue-700/20 hover:shadow-md hover:shadow-blue-300/20 transform hover:-translate-y-0.5"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Learn More
              <ArrowRight size={16} className="text-blue-600" />
            </Link>
            <div className="pt-3">
              <Button
                className="w-full relative bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium py-3 px-6 rounded-full transform transition-all hover:shadow-lg hover:shadow-blue-300/30"
                onClick={() => {
                  window.location.href = "#waitlist";
                  setIsMobileMenuOpen(false);
                }}
              >
                <span className="relative z-10">Join Waitlist</span>
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
